import { config } from 'util/config';
import { httpClient } from "util/Api";
import React, { Fragment } from 'react';
import moment from 'moment';
import { message, Tooltip, Row, Col, Form, Button, Input, DatePicker, TimePicker, Select, InputNumber, Switch, AutoComplete, Space, Checkbox } from 'antd';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { Colorpicker, ColorPickerValue } from 'antd-colorpicker'

//创建表单UI - uie
export function createUIElement({ uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value } = {}) {
  switch (uie.component) {
    case 'Label':
      return createLabel(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, component.state.formData[uie.source]);
    case 'Input':
      switch (uie.type) {
        case 'textarea':
          return createInputTextArea(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
        case 'password':
          return createInputPassword(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
        default:
          return createInput(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
      }
    case 'Select':
      return createSelect(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, component.state.componentDataSource[uie.source], value);
    case 'DatePicker':
      return createDatePicker(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'YearPicker':
      return createYearPicker(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'TimePicker':
      switch (uie.type) {
        case 'RangePicker':
          return createRangePicker(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
        default:
          return createTimePicker(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
      }
    case 'InputNumber':
      return createInputNumber(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'Switch':
      return createSwitch(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'Checkbox':
      return createCheckbox(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'AutoComplete':
      switch (uie.source) {
        case 'JobSearchAddress':
        case 'SearchAddressFromHyperFlo':
          return createJobSearchAddress(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, component.state.componentDataSource[uie.source], value);
        default:
          return createAutoComplete(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, component.state.componentDataSource[uie.source], value);
      }
    case 'RichTextEditor':
      return createRichTextEditor(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'ColorPicker':
      return createColorPicker(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'Button':
      return createButton(uie, uieCounter, component, formComponent, sectionComponent, pageComponent, value);
    case 'Empty':
      return <></>;
    default:
      return <>Unset Control: {uie.component}</>;
  }
}

//----------------- Label -----------------//
export function createLabel(uie, i, component, formComponent, sectionComponent, pageComponent, text) {
  return <>{text}</>
}

//----------------- Input -----------------//
export function createInput(uie, i, component, formComponent, sectionComponent, pageComponent, value) {
  return <Input
    autoComplete="off"
    addonBefore={uie.addonBefore}
    addonAfter={uie.addonAfter}
    className={uie.className}
    bordered={config.component.bordered}
    id={!globalFunction.isNullOrEmpty(uie.id) ? uie.id : uie.source}
    maxLength={uie.maxLength}
    showCount={uie.showCount}
    size={config.component.size}
    placeholder={uie.placeholder}
    defaultValue={value}
    onChange={(e) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: e.target.value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

export function createInputTextArea(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <Input.TextArea
    autoComplete="off"
    className={uie.className}
    bordered={config.component.bordered}
    id={uie.source}
    maxLength={uie.maxLength}
    showCount={uie.showCount}
    size={config.component.size}
    placeholder={uie.placeholder}
    rows={config.component.Input.Textarea.rows}
    onChange={(e) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: e.target.value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

export function createInputPassword(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <Input.Password
    autoComplete="new-password"
    className={uie.className}
    bordered={config.component.bordered}
    id={uie.source}
    maxLength={uie.maxLength}
    showCount={uie.showCount}
    size={config.component.size}
    placeholder={uie.placeholder}
    onChange={(e) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: e.target.value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- Select -----------------//
export function createSelect(uie, i, component, formComponent, sectionComponent, pageComponent, source, value) {
  // 判断如果是多选，去掉数据源里值是''的，并设置最大选择数量
  var maxSelect = null;
  if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
    if (source !== undefined) {
      source = source.filter(item => item.Value !== '' && item.Value !== '0' && item.Value !== 0);
    }
    if (uie.type !== 'multiple') {
      let parts = uie.type.split('-');
      maxSelect = parseInt(parts[1])
      uie.type = 'multiple';
    }
  }

  return <Select
    value={value}
    className={uie.className}
    mode={uie.type}
    bordered={config.component.bordered}
    id={uie.source}
    size={config.component.size}
    placeholder={uie.placeholder}
    placement={uie.placement}
    listHeight={360}
    showSearch
    filterOption={(inputValue, option) => {
      if (uie.type === 'group') {
        return option.options === undefined
          ? option?.children?.toLowerCase().includes(inputValue.toLowerCase())
          : false
      } else {
        return option?.children?.toLowerCase().includes(inputValue.toLowerCase())
      }
    }}
    getPopupContainer={triggerNode => triggerNode.parentElement}
    onDropdownVisibleChange={handleDropdownVisibleChange}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, data: getOptionData(source, uie, value), formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  >
    {
      source !== undefined ?
        uie.type === 'group' || uie.type === 'Notify' ?
          source.map(group => (
            group.SelectOptionList !== null ?
              <Select.OptGroup style={{ color: group.Color }} key={group.Value} label={group.Key}>
                {
                  group.SelectOptionList.map(option => (
                    <Select.Option style={{ color: option.Color }} key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                  ))
                }
              </Select.OptGroup>
              :
              <Select.Option style={{ color: group.Color }} key={group.Value} value={group.Value}>{group.Key}</Select.Option>
          ))
          :
          source.map(option => (
            <Select.Option style={{ color: option.Color }} key={option.Value} value={option.Value}>{option.Key}</Select.Option>
          ))
        : null
    }
  </Select>
}

function getOptionData(source, uie, value) {
  let data = {};
  if (source !== undefined) {
    if (uie.type === 'group') {
      source.map(group => {
        if (group.SelectOptionList !== null) {
          group.SelectOptionList.map(option => {
            if (option.Value === value) {
              data = option;
            }
          })
        }
      })
    } else if (uie.type === 'Notify') {
      source.map(group => {
        if (group.SelectOptionList !== null) {
          group.SelectOptionList.map(option => {
            if (option.Value === value) {
              data = option;
            }
          })
        }
      })
    } else {
      source.map(option => {
        if (option.Value === value) {
          data = option;
        }
      })
    }
  }
  return data;
}

function handleDropdownVisibleChange(open) {
  toggleBodyScroll(!open);
};

function preventBodyScroll(e) {
  e.preventDefault();
};

function toggleBodyScroll(enable) {
  if (enable) {
    window.removeEventListener('wheel', preventBodyScroll, { passive: false });
  } else {
    window.addEventListener('wheel', preventBodyScroll, { passive: false });
  }
};

//----------------- DatePicker -----------------//
export function createDatePicker(uie, i, component, formComponent, sectionComponent, pageComponent) {
  let disabledDates = [];
  if (pageComponent.state.publicHoliday !== undefined && pageComponent.state.publicHoliday.length > 0) {
    disabledDates = pageComponent.state.publicHoliday;
  }

  return <DatePicker
    disabledDate={(current) => uie.type === 'weekday' && pageComponent.state.cutoffHours !== undefined && pageComponent.state.cutoffMinutes !== undefined ? globalFunction.getDisabledDate(current, disabledDates, pageComponent.state.cutoffHours, pageComponent.state.cutoffMinutes) : null}
    allowClear={false}
    showToday={false}
    renderExtraFooter={() =>
      <>
        <Button
          size='small'
          className='datepicker-footer-button'
          style={{ marginRight: '6px', backgroundColor: '#038fde' }}
          disabled={uie.type === 'weekday' && pageComponent.state.cutoffHours !== undefined && pageComponent.state.cutoffMinutes !== undefined ? globalFunction.getDisabledDate(moment(new Date(), config.format.date), disabledDates, pageComponent.state.cutoffHours, pageComponent.state.cutoffMinutes) : null}
          onClick={() => {
            document.getElementById(uie.source).blur();
            if (formComponent.formRef.current !== null) {
              formComponent.formRef.current?.setFieldValue(uie.source, moment(new Date(), config.format.date));
            } else {
              pageComponent.formRef.current?.setFieldValue(uie.source, moment(new Date(), config.format.date));
            }
          }}
        >TDY</Button>
        <Button
          size='small'
          className='datepicker-footer-button'
          style={{ marginRight: '6px', backgroundColor: '#ff9800' }}
          disabled={uie.type === 'weekday' && pageComponent.state.cutoffHours !== undefined && pageComponent.state.cutoffMinutes !== undefined ? globalFunction.getDisabledDate(moment(globalFunction.addDate(new Date(), 1), config.format.date), disabledDates, pageComponent.state.cutoffHours, pageComponent.state.cutoffMinutes) : null}
          onClick={() => {
            document.getElementById(uie.source).blur();
            if (formComponent.formRef.current !== null) {
              formComponent.formRef.current?.setFieldValue(uie.source, moment(globalFunction.addDate(new Date(), 1), config.format.date));
            } else {
              pageComponent.formRef.current?.setFieldValue(uie.source, moment(globalFunction.addDate(new Date(), 1), config.format.date));
            }
          }}
        >TMW</Button>
        <Button
          size='small'
          className='datepicker-footer-button'
          style={{ marginRight: '6px', backgroundColor: '#607d8b' }}
          disabled={uie.type === 'weekday' && pageComponent.state.cutoffHours !== undefined && pageComponent.state.cutoffMinutes !== undefined ? globalFunction.getDisabledDate(moment(globalFunction.addDate(new Date(), -1), config.format.date), disabledDates, pageComponent.state.cutoffHours, pageComponent.state.cutoffMinutes) : null}
          onClick={() => {
            document.getElementById(uie.source).blur();
            if (formComponent.formRef.current !== null) {
              formComponent.formRef.current?.setFieldValue(uie.source, moment(globalFunction.addDate(new Date(), -1), config.format.date));
            } else {
              pageComponent.formRef.current?.setFieldValue(uie.source, moment(globalFunction.addDate(new Date(), -1), config.format.date));
            }
          }}
        >YSTD</Button>
        <Button
          size='small'
          style={{ marginLeft: '66px' }}
          onClick={() => {
            document.getElementById(uie.source).blur();
            if (formComponent.formRef.current !== null) {
              formComponent.formRef.current?.setFieldValue(uie.source, undefined);
            } else {
              pageComponent.formRef.current?.setFieldValue(uie.source, undefined);
            }
            try {
              operationalFunction({ functionName: 'clear' + uie.source, sectionName: sectionComponent.props.sectionName, parameter: null, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie, showError: false })
            } catch (error) { }
          }}
        >Clear</Button>
      </>
    }
    className={uie.className}
    bordered={config.component.bordered}
    size={config.component.size}
    placeholder={uie.placeholder}
    style={{ width: '100%' }}
    format={config.component.DatePicker.dateFormat}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- YearPicker -----------------//
export function createYearPicker(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <DatePicker
    allowClear={false}
    picker="year"
    className={uie.className}
    bordered={config.component.bordered}
    size={config.component.size}
    placeholder={uie.placeholder}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- TimePicker -----------------//
export function createTimePicker(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <TimePicker
    format='HH:mm'
    className={uie.className}
    bordered={config.component.bordered}
    size={config.component.size}
    placeholder={uie.placeholder}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

export function createRangePicker(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <TimePicker.RangePicker
    format='HH:mm'
    className={uie.className}
    bordered={config.component.bordered}
    size={config.component.size}
    placeholder={uie.placeholder}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- InputNumber -----------------//
export function createInputNumber(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <InputNumber
    className={uie.className}
    bordered={config.component.bordered}
    size={config.component.size}
    placeholder={uie.placeholder}
    style={{ width: '100%' }}
    min={inputNumberMin(uie)}
    max={inputNumberMax(uie)}
    precision={inputNumberPrecision(uie)}
    formatter={(value, info, input) => inputNumberFormatter(value, info, input, uie)}
    parser={value => inputNumberParser(value, uie)}
    addonBefore={inputNumberAddonBefore(uie)}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//限定最小值
export function inputNumberMin(uie) {
  switch (uie.type) {
    case 'positiveInteger':
    case 'positiveFloat':
    case 'byte':
      return 0;
    default:
      return null;
  }
}

//限定最大值
export function inputNumberMax(uie) {
  switch (uie.type) {
    case 'byte':
      return 255;
    default:
      return null;
  }
}

//限定小数点精度
export function inputNumberPrecision(uie) {
  switch (uie.type) {
    case 'money':
    case 'moneyNegative':
      return 2;
    case 'money3':
    case 'money3Negative':
      return 3;
    case 'positiveInteger':
    case 'byte':
      return 0;
    default:
      return 99;
  }
}

//数值格式化成字符串
export function inputNumberFormatter(value, info, input, uie) {
  switch (uie.type) {
    case 'money':
      return globalFunction.formatMoneyForControl(value, info, 2);
    case 'money3':
      return globalFunction.formatMoneyForControl(value, info, 3);
    case 'moneyNegative':
      return globalFunction.formatMoneyForControl(value, info, 2, true);
    case 'money3Negative':
      return globalFunction.formatMoneyForControl(value, info, 3, true);
    default:
      return value;
  }
}

//字符串格式化成数值
export function inputNumberParser(value, uie) {
  switch (uie.type) {
    case 'money':
    case 'money3':
      return globalFunction.parserMoneyForControl(value);
    case 'moneyNegative':
    case 'money3Negative':
      return globalFunction.parserMoneyForControl(value, true);
    default:
      return value;
  }
}

//控件前缀
export function inputNumberAddonBefore(uie) {
  switch (uie.type) {
    case 'money':
      return '$';
    default:
      return null;
  }
}

//----------------- Switch -----------------//
export function createSwitch(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <Switch
    className={uie.className}
    size={config.component.size}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- Checkbox -----------------//
export function createCheckbox(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <Checkbox
    className={uie.className}
    onChange={(e) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: e.target.checked, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  >{uie.placeholder}</Checkbox>
}

//----------------- AutoComplete -----------------//
export function createAutoComplete(uie, i, component, formComponent, sectionComponent, pageComponent, source) {
  return <AutoComplete
    className={uie.className}
    options={source !== undefined ? source : []}
    size={config.component.size}
    placeholder={uie.placeholder}
    onSelect={(value, option) => operationalFunction({ functionName: uie.onSelect, sectionName: sectionComponent.props.sectionName, parameter: option, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
    onSearch={(value) => operationalFunction({ functionName: uie.onSearch, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

export function createJobSearchAddress(uie, i, component, formComponent, sectionComponent, pageComponent, source) {
  return <AutoComplete
    className={uie.className}
    options={source !== undefined ? source : []}
    size={config.component.size}
    placeholder={uie.placeholder}
    notFoundContent={source !== undefined && source !== null && source.length === 0 && pageComponent.state.address !== undefined && pageComponent.state.address !== null && pageComponent.state.address.length >= 3 ? 'No address found.' : null}
    onSelect={(value, option) => operationalFunction({ functionName: uie.onSelect, sectionName: sectionComponent.props.sectionName, parameter: option, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
    onSearch={(value) => operationalFunction({ functionName: uie.onSearch, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
    onChange={(value) => operationalFunction({ functionName: uie.onChange, sectionName: sectionComponent.props.sectionName, parameter: value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie })}
  />
}

//----------------- RichTextEditor -----------------//
export function createRichTextEditor(uie, i, component, formComponent, sectionComponent, pageComponent, value) {
  return <CKEditor
    editor={DecoupledEditor}
    onReady={editor => {
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
    }}
    onChange={(event, editor) => {
    }}
    onBlur={(event, editor) => {
    }}
    onFocus={(event, editor) => {
    }}
    config={config.component.CKEditor.config}
  />
}

//----------------- ColorPicker -----------------//
export function createColorPicker(uie, i, component, formComponent, sectionComponent, pageComponent, value) {
  return <Colorpicker popup />
}

//----------------- Button -----------------//
export function createButton(uie, i, component, formComponent, sectionComponent, pageComponent) {
  return <Button
    size={config.component.Button.size}
    type={uie.type}
    className={uie.className}
    onClick={() => operationalFunction({ uie: uie, functionName: uie.onClick, sectionName: sectionComponent.props.sectionName, sectionComponent: sectionComponent, pageComponent: pageComponent })}
  >{uie.placeholder}</Button>
}
